const usuarioDev = {
   codigo: '00',
   nombre: 'Desarrollo',
   apPaterno: 'Data',
   apMaterno: 'Service',
   usuario: 'DEV',
   email: 'dev@dscont.pe',
   condicion: 'Contratado',
   sucursal: 'CUS',
   avatar: '',
   especialidad: 'Programador',
   sistema: 'desarrollo',
   key: '25641ed8-bd91-4876-b361-e9909be07cec'
};
const initialState = {
   logged: false,
   intentoVerificar: false,
   msg: '',
   usuario: {},
   appInfo: null,
   token: ''
};

const sliceConfig = {
   name: 'auth',
   initialState: initialState,
   reducers: {
      logOut(state) {
         state.logged = false;
         state.usuario = initialState.usuario;
         state.token = initialState.token;
         state.intentoVerificar = initialState.intentoVerificar;
         state.msg = initialState.msg;
         state.appInfo = initialState.appInfo;
      },
      verificar(state, action) {
         const usuario = action.payload;
         let nuevaData = {usuario: {}, logged: false, intentoVerificar: true};
         if (usuario && usuario.codigo) {
            nuevaData.logged = true;
            nuevaData.usuario = usuario;
         }
         if (process.env.REACT_APP_DS_ENV === 'PROD') {
            state.logged = nuevaData.logged;
            state.usuario = nuevaData.usuario;
            state.intentoVerificar = nuevaData.intentoVerificar;
         } else {
            state.intentoVerificar = true;
            state.logged = true;
            state.usuario = usuarioDev;
         }
      },
      logIn(state) {
         let nuevaData = {usuario: {}, logged: false, msg: '', token: '', appInfo: null};
         if (usuario && usuario.codigo) {
            const fechaVigencia = new Date(usuario.fechaVigencia);
            if (fechaVigencia > new Date()) {
               nuevaData.usuario = usuario;
               nuevaData.logged = true;
            } else {
               nuevaData.msg = 'Su fecha de vigencia ha finalizado.';
            }
         } else {
            nuevaData.msg = 'Usuario o Password incorrectos.';
         }
         state.usuario = nuevaData.usuario;
         state.logged = nuevaData.logged;
         state.msg = nuevaData.msg;
         state.token = nuevaData.token;
         state.appInfo = nuevaData.appInfo;
      }
   }
};

export default sliceConfig;
